import React from "react";
export default function OR() {
  return <div>Excel_OR</div>;
}
